import {initSquarePayments} from './square/square';
import {initSquareAddPaymentMethodPage} from './square/add-payment-method-page';
import {installCaptchaScript} from './botProtection';
import {getCheckoutForm} from './checkout';
import {initStripePayments} from './stripe/stripe';
import {initAuthnetPayments} from './authnet/authnet';
import {initPayPalPayments} from './paypal/paypal';
import {initPeachPayPayments} from './peachpay';
import {initAddressAutocomplete} from './address-auto-complete';
import {Feature} from './features';
import {FeatureFlag} from '../../@type/features';
import {$qs} from '../../@shared/ts/dom';
import {peachpayUpdateCurrencyCookie} from '../../@shared/ts/currency';
import {initAddPaymentMethodPage} from './stripe/add-payment-method-page';

async function main() {
	// Checkout page and Customer Payment (order-pay) have differing forms
	const $checkoutForm = getCheckoutForm();
	const $addPaymentMethodForm = $qs<HTMLFormElement>('form#add_payment_method');
	const $changePaymentMethod = window.location.href.includes('change_payment_method');

	if ($addPaymentMethodForm) {
		await initAddPaymentMethodPage($addPaymentMethodForm);
	}

	if ($checkoutForm && $changePaymentMethod) {
		await initAddPaymentMethodPage($checkoutForm);
		await initSquareAddPaymentMethodPage($checkoutForm);
	}

	if (!$checkoutForm || $changePaymentMethod) {
		return;
	}

	initAddressAutocomplete();

	if (Feature.enabled(FeatureFlag.BOT_PROTECTION)) {
		installCaptchaScript();
	}

	const [name, data] = location.hash.split('=');
	if (name === '#payment_data' && data) {
		jQuery($checkoutForm).block({
			message: null,
			overlayCSS: {
				background: '#fff',
				opacity: 0.6,
			},
		});
	}

	await Promise.all([
		initStripePayments($checkoutForm),
		initSquarePayments($checkoutForm),
		initPeachPayPayments($checkoutForm),
		initPayPalPayments(),
		initAuthnetPayments($checkoutForm),
	]);

	// Trigger hash change manually if needed (page reloaded instead of hash change)
	if (name === '#payment_data' && data) {
		window.dispatchEvent(new Event('hashchange'));
	}

	jQuery('input[name="billing_email"],input[name="payment_method"]').on('change', () => {
		jQuery(document.body).trigger('update_checkout');
	});
}

document.addEventListener('DOMContentLoaded', async () => main());

// Attach the event listeners for the default currency switching behavior when a
// payment method does not support the current currency
document.addEventListener('click', e => {
	const $target = (e.target as HTMLElement).closest('button[data-currency]');
	if ($target === null) {
		return;
	}

	const currencyToSwitchTo = $target.getAttribute('data-currency');
	if (currencyToSwitchTo === null) {
		return;
	}

	peachpayUpdateCurrencyCookie(currencyToSwitchTo);
	window.location.reload();
});
